module.exports = __webpack_public_path__ + "static/media/Inventory_icon.ac0c9d2f.png";